// 初期表示
export const PAGE_INIT = "homes/PAGE_INIT";
